// extracted by mini-css-extract-plugin
module.exports = {"downloadPdf":"AssetProfileDownloadPdfLink_downloadPdf__pMQ3W"};